import React, { Component } from 'react';
import T from 'i18n-react';

// Components
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
// Style
import './DialogAlertError.css';
// Constants
import COLORS from '../../enums/ColorEnum';

class DialogAlertError extends Component {

    constructor(props) {
        super(props);
        this.defaultProps = {
            errorMessage: T.translate('errors.defaultLabel')
        };
    }

    /**
     * Retourne le style du titre de la modal
     * @returns {Object}
     */
    getTitleStyle() {
        return {
            color: COLORS.RED,
            fontWeight: '500'
        };
    };

    /**
     * Retourne les configurations du bouton de la modal
     * @returns {Object}
     */
    getButtonConfigs() {
        return {
            backgroundColor: COLORS.RED,
            labelColor: COLORS.WHITE
        }
    };

    render() {
        const modalTitleStyle = this.getTitleStyle();
        const modalButtonConfigs = this.getButtonConfigs();

        return (
            <Dialog title={T.translate('errors.defaultLabel')}
                    titleClassName="dialog-alert-title"
                    bodyClassName="dialog-alert-container"
                    titleStyle={modalTitleStyle}
                    modal={false}
                    open={this.props.open}
                    onRequestClose={this.props.onClose}>
                <span className="dialog-alert-message">{this.props.errorMessage}</span>
                <RaisedButton label={T.translate('common.ok')}
                              className="dialog-alert-button"
                              onClick={this.props.onClose}
                              {...modalButtonConfigs}/>
            </Dialog>
        );
    }

}

export default DialogAlertError;



// WEBPACK FOOTER //
// ./src/components/dialogAlertError/DialogAlertError.js